import EmptyStateImg from 'assets/images/custom_empty_state.png'

import s from './ErrorState.module.css'

export const ErrorState = () => {
  return (
    <div className={s.wrapper}>
      <img src={EmptyStateImg} className={s.image} alt="error" />
      <h3>There&apos;s something wrong...</h3>
      <p className={s.hint}>
        Try refreshing the page (Ctrl + R/ Cmd +Shift + R).
      </p>
      <p className={s.hint}>
        Still not solved? Reach out to our support team for assistance.
      </p>
    </div>
  )
}
